import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

function CalendarDownload() {
    const { lang, orderId } = useParams();

    useEffect(() => {
        const fetchAndDownloadFile = async () => {
            try {
                const response = await fetch(
                    `https://api.wiseclean.ee/api:t2VGHK4N/order/add_to_calendar?OrderID=${orderId}&lang=${lang}`
                );

                if (response.ok) {
                    const blob = await response.blob();
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'calendar.ics';
                    link.setAttribute('type', 'text/calendar;charset=UTF-8');
                    link.setAttribute('Content-Disposition', 'attachment; filename="calendar.ics"');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Закрываем страницу после скачивания
                    window.close();
                } else {
                    console.error('Failed to fetch calendar file:', response.status);
                }
            } catch (error) {
                console.error('Error fetching calendar file:', error);
            }
        };

        fetchAndDownloadFile();
    }, [lang, orderId]);

    return null;
}

export default CalendarDownload;
